import api from '../api';

const fetchProcessingXLS = (params = {}, responseType = '', headers = {}) => {
  return api.get(`/processing/xls`, {
    params: {
      ...params,
    },
    responseType: `${responseType}`,
    headers: {
      ...headers,
    },
  });
};
const fetchProcessingPDF = (params = {}, responseType = '', headers = {}) => {
  return api.get(`/processing/pdf`, {
    params: {
      ...params,
    },
    responseType: `${responseType}`,
    headers: {
      ...headers,
    },
  });
};

const fetchProcessingReportsZip = (idHarvest, responseType = '', headers = {}) => {
  return api.get(`/processing/${idHarvest}`, {
    responseType: `${responseType}`,
    headers: {
      ...headers,
    },
  });
};

const fetchProcessingReportsMilkZip = (params = {}, responseType = '', headers = {}) => {
  return api.get(`/processing/milk`, {
    params: {
      ...params,
    },
    responseType: `${responseType}`,
    headers: {
      ...headers,
    },
  });
};

export {fetchProcessingXLS, fetchProcessingPDF, fetchProcessingReportsZip, fetchProcessingReportsMilkZip};
